import React from 'react';
import { AccordionItem } from './ui/Accordion';
import { tomos } from './data';
export function TomosAccordion() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-172">
      <div className="text-center mb-12" data-id="element-173">
        <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-174">
          El Sistema <span className="text-amber-400" data-id="element-175">Paso a Paso</span>
        </h2>
        <p className="text-xl text-zinc-400" data-id="element-176">
          10 tomos diseñados específicamente para las demandas del combate.
        </p>
      </div>

      <div className="space-y-1" data-id="element-177">
        {tomos.map((tomo, index) => <AccordionItem key={index} title={tomo.title} isOpen={index === 0} data-id="element-178">
            <ul className="space-y-3" data-id="element-179">
              {tomo.content.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-180">
                  <span className="text-amber-400 mt-1" data-id="element-181">•</span>
                  <span className="leading-relaxed" data-id="element-182">{item}</span>
                </li>)}
            </ul>
          </AccordionItem>)}
      </div>
    </section>;
}